export function initMenuTable(){
    const menuStart = document.querySelector('.main-menu__start') as HTMLElement | null;
    if (!menuStart) return;

    const toggleBtn = menuStart.querySelector('.menu-tablet') as HTMLElement | null;
    if (!toggleBtn) return;

    // Клик по кнопке — toggle
    toggleBtn.addEventListener('click', (e) => {
        e.stopPropagation();
        menuStart.classList.toggle('active');
    });

    // Клики вне меню — закрываем
    document.addEventListener('click', (e) => {
        const target = e.target as HTMLElement;
        if (!menuStart.contains(target)) {
            menuStart.classList.remove('active');
        }
    });
}